import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { TemplateDetailLoader } from './templateDetailInterface';
import { TemplateDetailAggregate } from './templateDetailModel';
import { TemplateDetailLoaderProps } from './templateDetailProps';
import { TemplateItemAggregate } from '../item';
import { useMemo } from 'react';

export function createTemplateDetailLoader(
    config: ReportingShellLoaderBaseConfig
): TemplateDetailLoader {
    const {
        repository,
        kernel: {
            infra: { formatter },
        },
    } = config;

    return {
        useLoad(context, props): TemplateDetailAggregate {
            // Load the integration tool by ID
            const integrationToolQuery = repository.platform.integrationTool.useRetrieve(
                context,
                props.template.id,
                { suspense: true }
            );
            assert(integrationToolQuery.status === 'success', 'expected suspense');

            // Load the integration definition for this tool using the new useRetrieve method
            const tool = integrationToolQuery.data;
            const integrationDefinitionQuery =
                repository.platform.integrationDefinition.useRetrieve(
                    context,
                    tool.integration_definition_id,
                    { suspense: true }
                );
            assert(integrationDefinitionQuery.status === 'success', 'expected suspense');

            // Load the integration tool config
            const integrationToolConfigQuery =
                repository.platform.integrationToolConfig.useRetrieve(context, tool.id, {
                    suspense: true,
                });
            assert(integrationToolConfigQuery.status === 'success', 'expected suspense');

            const definition = integrationDefinitionQuery.data;
            const config = integrationToolConfigQuery.data;

            // Create the template aggregate
            const item: TemplateItemAggregate = useMemo(() => {
                return {
                    tool,
                    definition,
                };
            }, [tool, config, definition]);

            return {
                item,
                config,
            };
        },
    };
}
